<script setup lang="ts">
import { ref } from 'vue';
import FsumDialog from '@/components/Utilities/FsumDialog.vue';

defineProps<{
    title?: string;
    message?: string;
}>();

const dialogRef = ref<typeof FsumDialog>();
</script>
<template>
    <FsumDialog
        ref="dialogRef"
        :title="title"
        :message="message"
        :persistent="false"
    >
        <template #actions>
            <q-card-actions align="right">
                <q-btn
                    v-close-popup="true"
                    class="fsum-button-dark-blue"
                    label="OK"
                />
            </q-card-actions>
        </template>
    </FsumDialog>
</template>
<style scoped>
:deep(.q-dialog-plugin) {
    padding: 8px;
}
:deep(.q-card__actions) {
    padding: 0px 16px 16px;
}
</style>
